import React, { useEffect, useState } from "react";
import { useOrganizationVendors, usePrimaryOrganizationId } from "../../hooks";
import { Checkbox } from "../../../common/components/input/Checkbox";
import { Api } from "../../../common/service/Api";
import { Button } from "@mui/material";
import { Form } from "react-final-form";
import { YotpoMigrationRequestDto } from "../../../common/service/server/dto/OrganizationDataRecipientDto";

// TODO: POL-5332 Remove Yotpo migration code after all orgs have completed migration
// These IDs are from the vendor database
export const YOTPO_LEGACY_VENDOR_ID = "84147538-ad70-4c67-9096-728c69b49b03";
const YOTPO_LOYALTY_REFERRALS_VENDOR_ID = "dc977dea-ac13-440c-a448-a3b6db9c747f";
const YOTPO_REVIEWS_UGC_VENDOR_ID = "9c2addb3-98d9-4670-a10f-11f0acd91e4a";
const YOTPO_SMS_EMAIL_MARKETING_VENDOR_ID = "ad54cca4-4edb-48c9-854a-8169d3838238";
const YOTPO_SUBSCRIPTIONS_VENDOR_ID = "001ccdc3-b339-4b63-94fa-9e2e1bcf413c";

export const YotpoVendorMigrationPrompt = ({ onComplete }: { onComplete: () => void }) => {
  const orgId = usePrimaryOrganizationId();
  const [allVendors, vendorsRequest] = useOrganizationVendors(orgId);

  // Keep track of state in a map from each of the 4 Yotpo services to whether it is selected
  const [selectedVendors, setSelectedVendors] = useState({
    [YOTPO_LOYALTY_REFERRALS_VENDOR_ID]: false,
    [YOTPO_REVIEWS_UGC_VENDOR_ID]: false,
    [YOTPO_SMS_EMAIL_MARKETING_VENDOR_ID]: false,
    [YOTPO_SUBSCRIPTIONS_VENDOR_ID]: false,
  });

  useEffect(() => {
    if (vendorsRequest.success) {
      setSelectedVendors({
        [YOTPO_LOYALTY_REFERRALS_VENDOR_ID]: allVendors.some(
          (v) => v.vendorId === YOTPO_LOYALTY_REFERRALS_VENDOR_ID,
        ),
        [YOTPO_REVIEWS_UGC_VENDOR_ID]: allVendors.some(
          (v) => v.vendorId === YOTPO_REVIEWS_UGC_VENDOR_ID,
        ),
        [YOTPO_SMS_EMAIL_MARKETING_VENDOR_ID]: allVendors.some(
          (v) => v.vendorId === YOTPO_SMS_EMAIL_MARKETING_VENDOR_ID,
        ),
        [YOTPO_SUBSCRIPTIONS_VENDOR_ID]: allVendors.some(
          (v) => v.vendorId === YOTPO_SUBSCRIPTIONS_VENDOR_ID,
        ),
      });
    }
  }, [vendorsRequest]);

  return (
    <div>
      <p>
        Select all Yotpo services your organization uses. Any services you previously added to your
        Data Map are pre-selected. If you no longer use that service, unselect it.
      </p>

      <div>
        <Form
          initialValues={selectedVendors}
          onSubmit={async (values) => {
            let migrationRequestDto: YotpoMigrationRequestDto = {
              yotpoLoyaltyRewards: values[YOTPO_LOYALTY_REFERRALS_VENDOR_ID],
              yotpoReviewsUgc: values[YOTPO_REVIEWS_UGC_VENDOR_ID],
              yotpoSubscriptions: values[YOTPO_SUBSCRIPTIONS_VENDOR_ID],
              yotpoSmsEmailMarketing: values[YOTPO_SMS_EMAIL_MARKETING_VENDOR_ID],
            };

            await Api.organizationVendor.migrateYotpo(orgId, migrationRequestDto);

            onComplete();
          }}
          render={({ handleSubmit }) => (
            <>
              <Checkbox
                field={YOTPO_SUBSCRIPTIONS_VENDOR_ID}
                color="primary"
                label="Yotpo - Subscriptions"
              />
              <Checkbox
                field={YOTPO_SMS_EMAIL_MARKETING_VENDOR_ID}
                color="primary"
                label="Yotpo - SMS & Email Marketing"
              />
              <Checkbox
                field={YOTPO_REVIEWS_UGC_VENDOR_ID}
                color="primary"
                label="Yotpo - Reviews & UGC"
              />
              <Checkbox
                field={YOTPO_LOYALTY_REFERRALS_VENDOR_ID}
                color="primary"
                label="Yotpo - Loyalty & Referrals"
              />
              <footer className="d-flex flex-row justify-end">
                <Button
                  variant="contained"
                  color="primary"
                  // disabled={completing}
                  onClick={handleSubmit}
                >
                  Save
                </Button>
              </footer>
            </>
          )}
        />
      </div>
    </div>
  );
};
